var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"open-on-hover":"","open-delay":"150","right":"","disabled":_vm.disabled,"offset-x":"","nudge-right":"12"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_vm._t("activator",null,null,{ attrs: attrs, on: on })]}}],null,true)},[_c('v-card',{staticClass:"pa-3",attrs:{"color":"#6779A5","dark":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }